import React from "react";
import "./Plans.css";
import { plansData } from "../../data/plansData";
import whiteTick from "../../assets/whiteTick.png";

const Plans = () => {
  return (
    <div className="plans-container" id="plan">
      <div className="blur plans-blur-1"> </div>
      <div className="blur plans-blur-2"> </div>
      <div className="programs-header" style={{ gap: "2rem" }}>
        {/* Note: Css from other component (programs-header) is used here without importing any component. */}
        <span className="stroke-text">READY TO START</span>
        <span>YOUR JOURNEY</span>
        <span className="stroke-text">WITH US</span>
      </div>
      {/* Plans Cards */}
      <div className="plans" >
        {/* plansData calling in jsx.file */}
        {plansData.map((plan, i) => (
          <div className="plan" key={i}>
            {plan.icon}
            <span>{plan.name}</span>
            <span>$ {plan.price}</span>
            {/* features array data calling in jsx file*/}
            <div className="features">
              {plan.features.map((feature, i) => (
                <div className="feature">
                  <img src={whiteTick} alt="" />
                  <span key={i}>{feature}</span>
                </div>
              ))}
            </div>
            {/* Feature mapping closed */}
            <div>
              <span>See more benefits -&gt </span>
            </div>
            <button className="btn">Join Now</button>
          </div>
        ))}
      </div>
    </div>
  );
};
// Now conitnue from (1:13:42) and complete testimonials components.
export default Plans;
